void 0 === Shopify && (window.Shopify = {}), void 0 === Shopify.getCart && (Shopify.getCart = function(t, e) {
    if (!e) return jQuery.getJSON("/cart.js", (function(e, a, r) {
        "function" == typeof t ? t(e, a, r) : Shopify.onCartUpdate(e)
    }));
    "function" == typeof t ? t(e) : "function" == typeof Shopify.onCartUpdate && Shopify.onCartUpdate(e)
});
var Shopify = Shopify || {};
Shopify.money_format = "£{{amount}}", Shopify.formatMoney = function(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    var a = "",
        r = /\{\{\s*(\w+)\s*\}\}/,
        i = e || this.money_format;

    function o(t, e) {
        return void 0 === t ? e : t
    }

    function n(t, e, a, r) {
        if (e = o(e, 2), a = o(a, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
        var i = (t = (t / 100).toFixed(e)).split(".");
        return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (i[1] ? r + i[1] : "")
    }
    switch (i.match(r)[1]) {
        case "amount":
            a = n(t, 2);
            break;
        case "amount_no_decimals":
            a = n(t, 0);
            break;
        case "amount_with_comma_separator":
            a = n(t, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            a = n(t, 0, ".", ",")
    }
    return i.replace(r, a)
};
class GoCart {
    constructor(t) {
        this.defaults = Object.assign({}, {
            cartModalFail: ".js-go-cart-modal-fail",
            cartModalFailClose: ".js-go-cart-modal-fail-close",
            cartModal: ".js-go-cart-modal",
            cartModalClose: ".js-go-cart-modal-close",
            cartModalContent: ".js-go-cart-modal-content",
            cartDrawer: ".js-go-cart-drawer",
            cartDrawerContent: ".js-go-cart-drawer-content",
            cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
            cartDrawerFooter: ".js-go-cart-drawer-footer",
            cartDrawerClose: ".js-go-cart-drawer-close",
            cartMiniCart: ".js-go-cart-mini-cart",
            cartMiniCartContent: ".js-go-cart-mini-cart-content",
            cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
            cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
            cartTrigger: ".js-go-cart-trigger",
            cartOverlay: ".js-go-cart-overlay",
            cartCount: ".js-go-cart-counter",
            addToCart: ".js-go-cart-add-to-cart",
            removeFromCart: ".js-go-cart-remove-from-cart",
            removeFromCartNoDot: "js-go-cart-remove-from-cart",
            itemQuantity: ".js-go-cart-quantity",
            itemQuantityPlus: ".js-go-cart-quantity-plus",
            itemQuantityMinus: ".js-go-cart-quantity-minus",
            cartMode: "drawer",
            drawerDirection: "right",
            displayModal: !1,
            moneyFormat: "£{{amount}}",
            labelAddedToCart: "was added to your cart.",
            labelCartIsEmpty: "Your Cart is currently empty!",
            labelQuantity: "Quantity:",
            labelRemove: "Remove"
        }, t), this.cartModalFail = document.querySelector(this.defaults.cartModalFail), this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose), this.cartModal = document.querySelector(this.defaults.cartModal), this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose), this.cartModalContent = document.querySelector(this.defaults.cartModalContent), this.cartDrawer = document.querySelector(this.defaults.cartDrawer), this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent), this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal), this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter), this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose), this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart), this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent), this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal), this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter), this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger), this.cartOverlay = document.querySelector(this.defaults.cartOverlay), this.cartCount = document.querySelector(this.defaults.cartCount), this.addToCart = document.querySelectorAll(this.defaults.addToCart), this.removeFromCart = this.defaults.removeFromCart, this.removeFromCartNoDot = this.defaults.removeFromCartNoDot, this.itemQuantity = this.defaults.itemQuantity, this.itemQuantityPlus = this.defaults.itemQuantityPlus, this.itemQuantityMinus = this.defaults.itemQuantityMinus, this.cartMode = this.defaults.cartMode, this.drawerDirection = this.defaults.drawerDirection, this.displayModal = this.defaults.displayModal, this.moneyFormat = this.defaults.moneyFormat, this.labelAddedToCart = this.defaults.labelAddedToCart, this.labelCartIsEmpty = this.defaults.labelCartIsEmpty, this.labelQuantity = this.defaults.labelQuantity, this.labelRemove = this.defaults.labelRemove, this.init()
    }
    get isDrawerMode() {
        return "drawer" === this.cartMode
    }
    init() {
        this.fetchCart(), this.isDrawerMode ? this.setDrawerDirection() : document.querySelector(".go-cart-wrp").classList.add("mini-cart"), document.addEventListener("click", (t => {
            if (t.target.matches(this.defaults.addToCart)) {
                t.preventDefault();
                let r = t.target.parentNode;
                for (;
                    "form" !== r.tagName.toLowerCase();) r = r.parentNode;
                const i = r.getAttribute("id");
                let o = document.querySelector("#curentvariant"),
                    n = parseInt(document.querySelector('input[name="quantity"]').value),
                    s = parseInt(document.querySelector(".inventoryNote").textContent);
                if (s) {
                    if (n <= s)
                        if (document.querySelectorAll(".go-cart-item__single").length > 0) {
                            let t = document.querySelectorAll(".go-cart-item__single");
                            var e = [];
                            for (let a of t) e.push(a.dataset.id);
                            if (e.find((t => t == o.value))) {
                                var a = s - parseInt(document.querySelector('[data-quantityid="' + o.value + '"]').value);
                                document.querySelector('[data-quantityid="' + o.value + '"]').value >= s || a < n || this.addItemToCart(i)
                            } else this.addItemToCart(i)
                        } else this.addItemToCart(i)
                } else this.addItemToCart(i)
            }
        }), !1), this.cartTrigger.forEach((t => {
            t.addEventListener("click", (() => {
                console.log(this), this.isDrawerMode ? this.openCartDrawer() : this.openMiniCart(), this.openCartOverlay()
            }))
        })), this.cartOverlay.addEventListener("click", (() => {
            this.closeCartModal(), this.isDrawerMode ? this.closeCartDrawer() : this.closeMiniCart(), this.closeCartOverlay()
        })), this.isDrawerMode && this.cartDrawerClose.addEventListener("click", (() => {
            this.closeCartDrawer(), this.closeCartOverlay()
        })), this.displayModal && this.cartModalClose.forEach((t => {
            t.addEventListener("click", (() => {
                this.closeCartModal(), this.isDrawerMode ? this.closeCartDrawer() : this.closeMiniCart(), this.closeCartOverlay()
            }))
        })), this.cartModalFailClose.addEventListener("click", (() => {
            this.closeCartModal(), this.isDrawerMode ? this.closeCartDrawer() : this.closeMiniCart(), this.closeCartOverlay()
        }))
    }
    fetchCart(t) {
        window.fetch("/cart.js", {
            credentials: "same-origin",
            method: "GET"
        }).then((t => t.json())).then((e => this.fetchHandler(e, t))).catch((t => {
            throw this.ajaxRequestFail(), new Error(t)
        }))
    }
    addItemToCart(t) {
        Shopify.getCart(function(e) {
            const a = document.querySelector(`#${t}`),
                r = new FormData(a);
            Array.from(r.entries()).reduce(((t, [e, a]) => ({
                ...t,
                [e]: a
            })), {});
            window.fetch("/cart/add.js", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: function(t) {
                    let e = 0;
                    for (var a = 0; a < t.elements.length; a++) {
                        "curentvariant_autodeliver" === (i = t.elements[a]).id && (e = i.value)
                    }
                    var r = [];
                    for (a = 0; a < t.elements.length; a++) {
                        var i;
                        if ((i = t.elements[a]).name && !i.disabled && "file" !== i.type && "reset" !== i.type && "submit" !== i.type && "button" !== i.type) {
                            if ("select-multiple" === i.type)
                                for (var o = 0; o < i.options.length; o++) i.options[o].selected && r.push(encodeURIComponent(i.name) + "=" + encodeURIComponent(i.options[o].value));
                            "id" === i.name ? (console.log("addddd"), console.log(i.type), "" != e ? r.push(encodeURIComponent(i.name) + "=" + encodeURIComponent(e)) : "radio" == i.type ? i.checked && r.push(encodeURIComponent(i.name) + "=" + encodeURIComponent(i.value)) : r.push(encodeURIComponent(i.name) + "=" + encodeURIComponent(i.value))) : ("checkbox" !== i.type && "radio" !== i.type || i.checked) && r.push(encodeURIComponent(i.name) + "=" + encodeURIComponent(i.value))
                        }
                    }
                    return console.log(r.join("&")), r.join("&")
                }(a)
            }).then((t => {
                t.json(), jQuery.getJSON("/cart.js", (function(t, e) {
                    let a = t.items,
                        r = 0;
                    a.forEach((function(t) {
                        let e = t.product_title;
                        "Free Gift w/ Purchase" != e && e.toLowerCase().startsWith("free") && (r = t.line_price)
                    })), r > 0 && jQuery(".FreeProductGridContainer .preview-card").each((function() {
                        jQuery(this).find(".form").remove(), jQuery(this).append('<button class="btn_disable btn_full" style="margin-top: 16px;" disabled="">UNAVAILABLE - FREE PRODUCT ALREADY IN CART</button>'), jQuery(".FreeProductGridContainer .preview-card").removeClass("open")
                    }))
                }))
            })).then((t => this.addItemToCartHandler(t))).catch((t => {
                throw this.ajaxRequestFail(), new Error(t)
            }))
        }.bind(this))
    }
    removeItem(t) {
        Shopify.getCart(function(e) {
            window.fetch("/cart/change.js", {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    quantity: 0,
                    line: t
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then((t => {
                t.json(), jQuery.getJSON("/cart.js", (function(t, e) {
                    add_product_to_cart(t, "minicart")
                }))
            })).then((() => this.fetchCart())).catch((t => {
                throw this.ajaxRequestFail(), new Error(t)
            }))
        }.bind(this))
    }
    changeItemQuantity(t, e, a) {
        Shopify.getCart(function(r) {
            window.fetch("/cart/change.js", {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    quantity: e,
                    line: t
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then((t => {
                t.json(), a > 0 && jQuery(".FreeProductGridContainer").length && location.reload(), jQuery.getJSON("/cart.js", (function(t, e) {
                    add_product_to_cart(t, "minicart")
                }))
            })).then((() => this.fetchCart())).catch((t => {
                throw this.ajaxRequestFail(), new Error(t)
            }))
        }.bind(this))
    }
    cartItemCount(t) {
        document.querySelectorAll(".js-go-cart-counter").forEach((e => {
            e.innerHTML = t.item_count
        }))
    }
    fetchAndOpenCart() {
        this.fetchCart((() => {
            this.isDrawerMode ? (console.log(1), this.openCartDrawer()) : (console.log(2), this.openMiniCart()), console.log(3), this.openCartOverlay()
        }))
    }
    fetchAndOpenModal(t) {
        this.fetchCart((() => {
            this.renderCartModal(t), this.openCartModal(), this.openCartOverlay()
        }))
    }
    fetchHandler(t, e) {
        this.cartItemCount(t), this.isDrawerMode ? 0 === t.item_count ? (this.renderBlankCartDrawer(), this.cartDrawerFooter.classList.add("is-invisible"), this.cartDrawerFooter.classList.remove("vis")) : (this.renderDrawerCart(t), this.cartDrawerFooter.classList.remove("is-invisible"), this.cartDrawerFooter.classList.add("vis"), "function" == typeof e && e(t)) : 0 === t.item_count ? (this.renderBlankMiniCart(), this.cartMiniCartFooter.classList.add("is-invisible"), this.cartMiniCartFooter.classList.remove("is-vis")) : (this.renderMiniCart(t), this.cartMiniCartFooter.classList.remove("is-invisible"), this.cartMiniCartFooter.classList.add("is-vis"), "function" == typeof e && e(t))
    }
    addItemToCartHandler(t) {
        return this.displayModal ? this.fetchAndOpenModal(t) : this.fetchAndOpenCart()
    }
    ajaxRequestFail() {}
    renderCartModal(t) {
        this.clearCartModal();
        let e = t.variant_title,
            a = t.image;
        console.log("sdf"), e = null === e ? "" : `(${e})`, a = null === a ? "" : t.image;
        const r = `\n<div class="go-cart-modal-item">\n<div class="go-cart-item__image" style="background-image: url(${a});"></div>\n<div class="go-cart-item__info">\n<a href="${t.url}" class="go-cart-item__title">${t.product_title} ${e}</a> ${this.labelAddedToCart}\n</div>\n</div>\n`;
        this.cartModalContent.innerHTML += r
    }
    renderDrawerCart(t) {
        this.clearCartDrawer(), t.items.forEach(((t, e) => {
            let a = t.product_title,
                r = "",
                i = "",
                o = t.variant_title,
                n = "",
                s = t.properties.shipping_interval_unit_type,
                c = t.properties.shipping_interval_frequency,
                l = "",
                d = "image_has";
            n = null == o ? "" : "Free Gift w/ Purchase" == a ? `${a}` : `${o}`;
            let u = !1;
            "Free Gift w/ Purchase" != a && a.toLowerCase().startsWith("free") ? (r = a.substring(5), u = !0) : "Free Gift w/ Purchase" == a ? (i = o, r = i.split("/")[0]) : r = `${a}`, l = void 0 !== t.selling_plan_allocation ? t.selling_plan_allocation.selling_plan.name : void 0 !== c && void 0 !== s ? `AUTO RENEWS EVERY ${c} ${s}` : "", null == t.image && (t.image = "", d = "image_not_has");
            let m = Shopify.formatMoney(t.line_price, this.moneyFormat),
                h = "";
            "£0.00" == m ? (m = "FREE", h = "d-none") : h = "";
            let p = "";
            if (t.image.includes(".png")) {
                let e = t.image.split(".png");
                p = e[0] + "_200x320.png" + e[1]
            } else if (t.image.includes(".jpg")) {
                let e = t.image.split(".jpg");
                p = e[0] + "_200x320.jpg" + e[1]
            } else if (t.image.includes(".jpeg")) {
                let e = t.image.split(".jpeg");
                p = e[0] + "_200x320.jpeg" + e[1]
            } else if (t.image.includes(".webp")) {
                let e = t.image.split(".webp");
                p = e[0] + "_200x320.webp" + e[1]
            }
            const y = `\n<div class="go-cart-item__single" data-line="${Number(e+1)}" data-id="${t.id}" data-handle="${t.handle}">\n<div class="go-cart-item__info-wrapper">\n<div class="go-cart-item__image ${d}" style="background-image: url(${p});"></div>\n<div class="go-cart-item__info">\n<div class="go-cart-item__wrp">\n${u?`<span class="go-cart-item__title_free fw_600 h6 mt0 mb10">${r}</span>`:`<a href="${t.url}" class="go-cart-item__title fw_600 h6 mt0 mb10">${r}</a>`}\n<div class="go-cart-item__variant fw_600 caps mt0 mb10">${n}</div>\n<div class="go-cart-item__variant fw_600 caps mt0 mb10 color-grey70">${l}</div>\n<div class="remove-link fw_600 caps mt26">\n<span class="js-go-cart-quantity-minus">${this.labelRemove}</span>\n<input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" data-quantityid="${t.id}" value="${t.quantity}" disabled hidden>\n</div>\n</div>\n<div class="quantity-wrp mb10">\n${u?'<div class="go-cart-item__price h5 m0 free-prod-after">FREE</div>':`<div class="go-cart-item__price h5 m0">${m === 'FREE' ? 'FREE' : m+''}</div>\n<div class="go-cart-item__quantity ${h}">\n<span class="go-cart-item__quantity-label">${this.labelQuantity} </span>\n<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>\n<input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" data-quantityid="${t.id}" value="${t.quantity}" disabled>\n<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>\n</div>\n`}\n\n\n</div>\n\n</div>\n\n</div>\n\n</div>\n`;
            this.cartDrawerContent.innerHTML += y
        }));
        let e = t.items,
            a = 0;
        e.forEach((function(t) {
            let e = t.product_title;
            "Free Gift w/ Purchase" != e && e.toLowerCase().startsWith("free") && (a = t.line_price)
        }));
        let r = t.total_price;
        a > 0 && (r = t.total_price - a), this.cartDrawerSubTotal.innerHTML = Shopify.formatMoney(r, this.moneyFormat), this.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");
        document.querySelectorAll(this.removeFromCart).forEach((t => {
            t.addEventListener("click", (() => {
                GoCart.removeItemAnimation(t.parentNode);
                const e = t.parentNode.parentNode.parentNode.getAttribute("data-line");
                this.removeItem(e)
            }))
        }));
        document.querySelectorAll(this.itemQuantityPlus).forEach((t => {
            t.addEventListener("click", (() => {
                const e = t.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                    a = Number(t.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(e, a, 0)
            }))
        }));
        document.querySelectorAll(this.itemQuantityMinus).forEach((t => {
            t.addEventListener("click", (() => {
                const e = t.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                    a = Number(t.parentNode.querySelector(this.itemQuantity).value) - 1;
                var r = 0;
                jQuery.getJSON("/cart.js", (function(t) {
                    let i = t.items[e - 1],
                        o = i.product_title;
                    "Free Gift w/ Purchase" != o && o.toLowerCase().startsWith("free") && (r = i.line_price), "Best Sellers Sample Kit" === o && (r = 1), (new GoCart).changeItemQuantity(e, a, r)
                })), 0 === Number(t.parentNode.querySelector(this.itemQuantity).value - 1) && GoCart.removeItemAnimation(t.parentNode.parentNode.parentNode.parentNode)
            }))
        })), getTagFirstMonthFree()
    }
    renderMiniCart(t) {
        this.clearMiniCart(), t.items.forEach(((t, e) => {
            let a = t.variant_title,
                r = t.image;
            null === a && (a = ""), null === r && (r = "");
            const i = `\n<div class="go-cart-item__single" data-line="${Number(e+1)}" data-id="${t.id}">\n<div class="go-cart-item__info-wrapper">\n<div class="go-cart-item__image" style="background-image: url(${r});"></div>\n<div class="go-cart-item__info">\n<a href="${t.url}" class="go-cart-item__title">${t.product_title}</a>\n<div class="go-cart-item__variant">${a}</div>\n<div class="go-cart-item__price">${Shopify.formatMoney(t.line_price,this.moneyFormat)}</div>\n<div class="go-cart-item__quantity">\n<span class="go-cart-item__quantity-label">${this.labelQuantity} </span>\n<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>\n<input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" data-quantityid="${t.id}" value="${t.quantity}" disabled>\n<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>\n</div>\n</div>\n</div>\n\n<a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>\n</div>\n`;
            this.cartMiniCartContent.innerHTML += i
        })), this.cartMiniCartSubTotal.innerHTML = Shopify.formatMoney(t.total_price, this.moneyFormat), this.cartMiniCartSubTotal.parentNode.classList.remove("is-invisible");
        document.querySelectorAll(this.removeFromCart).forEach((t => {
            t.addEventListener("click", (() => {
                GoCart.removeItemAnimation(t.parentNode);
                const e = t.parentNode.getAttribute("data-line");
                this.removeItem(e)
            }))
        }));
        document.querySelectorAll(this.itemQuantityPlus).forEach((t => {
            t.addEventListener("click", (() => {
                const e = t.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                    a = Number(t.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(e, a, 0)
            }))
        }));
        document.querySelectorAll(this.itemQuantityMinus).forEach((t => {
            t.addEventListener("click", (() => {
                const e = t.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                    a = Number(t.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(e, a, 0), 0 === Number(t.parentNode.querySelector(this.itemQuantity).value - 1) && jQuery.getJSON("/cart.js", (function(e, a) {
                    let r = e.items,
                        i = 0;
                    r.forEach((function(t) {
                        let e = t.product_title;
                        "Free Gift w/ Purchase" != e && e.toLowerCase().startsWith("free") && "Best Sellers Kit" != e && (i = t.line_price)
                    })), GoCart.removeItemAnimation(t.parentNode.parentNode.parentNode.parentNode), i > 0 && location.reload()
                }))
            }))
        }))
    }
    renderBlankCartDrawer() {
        this.cartDrawerSubTotal.parentNode.classList.add("is-invisible"), this.clearCartDrawer(), this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`
    }
    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add("is-invisible"), this.clearMiniCart(), this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`
    }
    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = ""
    }
    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = ""
    }
    clearCartModal() {
        this.cartModalContent.innerHTML = ""
    }
    openCartDrawer() {
        this.cartDrawer.classList.add("is-open"), document.querySelector("body").classList.add("overflow-hidden")
    }
    closeCartDrawer() {
        this.cartDrawer.classList.remove("is-open"), document.querySelector("body").classList.remove("overflow-hidden")
    }
    openMiniCart() {
        this.cartMiniCart.classList.add("is-open")
    }
    closeMiniCart() {
        this.cartMiniCart.classList.remove("is-open")
    }
    openCartModal() {
        this.cartModal.classList.add("is-open")
    }
    closeCartModal() {
        this.cartModal.classList.remove("is-open")
    }
    openCartOverlay() {
        this.cartOverlay.classList.add("is-open")
    }
    closeCartOverlay() {
        this.cartOverlay.classList.remove("is-open")
    }
    static removeItemAnimation(t) {
        t.classList.add("is-invisible")
    }
    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`)
    }
}
document.querySelector(".js-go-cart-mini-cart-close").addEventListener("click", (function() {
    setTimeout((function() {
        document.querySelector(".js-go-cart-mini-cart").classList.remove("is-open"), document.querySelector(".js-go-cart-overlay").classList.remove("is-open")
    }), 100)
}));
var goCart = new GoCart({
    cartMode: "drawer"
});

function getTagFirstMonthFree() {
    setTimeout((function() {
        document.querySelectorAll(".go-cart-item__single").forEach((t => {
            first_month_free.find((e => {
                e == t.dataset.handle && t.querySelector(".go-cart-item__wrp").classList.add("mc-fmf")
            })), limit_1_per_order.find((e => {
                e == t.dataset.handle && t.querySelectorAll(".go-cart-item__quantity").length > 0 && t.querySelector(".go-cart-item__quantity").classList.add("d-none")
            }))
        }))
    }), 2e3)
}
"mini-cart" == goCart.cartMode && document.querySelector(".js-go-cart-mini-cart").classList.remove("hidden"), getTagFirstMonthFree();